export default __webpack_public_path__ + "static/media/FgvLogo.95d3942a.png";